import { render, staticRenderFns } from "./verificationPublic.vue?vue&type=template&id=9855631a&scoped=true&"
import script from "./verificationPublic.vue?vue&type=script&lang=js&"
export * from "./verificationPublic.vue?vue&type=script&lang=js&"
import style0 from "./verificationPublic.vue?vue&type=style&index=0&lang=less&"
import style1 from "./verificationPublic.vue?vue&type=style&index=1&id=9855631a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9855631a",
  null
  
)

export default component.exports